import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslatePipe } from '@ngx-translate/core';

import { Filetype } from '@modules/card/enums/filetype.enum';

@Component({
  selector: 'mb-document-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class DocumentPreviewComponent {
  private sanitizer = inject(DomSanitizer);

  @Input()
  set url(v: any) {
    const x = this.sanitizer.bypassSecurityTrustResourceUrl(v);
    this._url = x;
  }
  get url() {
    return this._url;
  }

  @Input() title!: string;
  @Input() filetype!: Filetype;
  @Input() filetypeName!: string;
  @Input() showOpenButton: boolean = true;

  private _url!: SafeResourceUrl;
}
